import { render, staticRenderFns } from "./chat-start-page.vue?vue&type=template&id=56d033b0&scoped=true"
import script from "./chat-start-page.vue?vue&type=script&lang=js"
export * from "./chat-start-page.vue?vue&type=script&lang=js"
import style0 from "./chat-start-page.vue?vue&type=style&index=0&id=56d033b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d033b0",
  null
  
)

export default component.exports